import { connect } from 'react-redux';
import * as R from 'ramda';
import MobileMenu from './MobileActivationToggleMenu';

import { getFilterIdentifierCount } from '../../../filters/store/filtersSlice';
import {
  getCurrentSelection,
  setDialogDetails,
  toggleBatchActivation,
} from '../../store/supplierAuthorizationSlice';

const mapState = state => ({
  activeSupplierAuthTab: state.loadingManagement.supplierAuthorizations.activeSupplierAuthTab,
  filterIdentifierCount: getFilterIdentifierCount(state),
  nameShort: R.o(R.prop('nameShort'), getCurrentSelection)(state),
  supplierAuthorizations: state.loadingManagement.supplierAuthorizations.supplierAuthorizations,
  supplierAuthorizationsCards:
    state.loadingManagement.supplierAuthorizations.supplierAuthorizationsCards,
});

const mapDispatchToProps = {
  setDialogDetails,
  toggleBatchActivation,
};

export default connect(mapState, mapDispatchToProps)(MobileMenu);
